// extracted by mini-css-extract-plugin
export default {"designBtn":"designButton_designBtn__1Bd00"};